import React from "react";
import Icons from "../../../components/icons";
import { NavigationIconProps } from "../types";
import { StyledIconWrapper } from "./styled";

const NavigationIcon = ({
  hasChildren,
  isDropdownOpen,
  isSelected,
}: NavigationIconProps) => {
  if (!hasChildren) return null;
  const IconComponent = isDropdownOpen ? Icons.CaretDown : Icons.CaretRight;
  return (
    <StyledIconWrapper isSelected={isSelected}>
      <IconComponent />
    </StyledIconWrapper>
  );
};

export default NavigationIcon;
